import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { AccessKey } from 'src/features/accessKey/utils/types';

const RESOURCE = `sp-core/:parkingId/visitors/access-key/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<AccessKey>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_ACCESS_KEYS_RESOURCE, useQueryHook as useListAccessKeys };
